const HTTP_URL_PREFIX_PATTERN = /^https?:\/\//i
const URL_SCHEME_PATTERN = /^[a-z][a-z\d+.-]*:/i
const HOST_PORT_PATTERN = /^(?:[^/?#:\s]+\.[^/?#:\s]+|\[[\da-f:]+\]):\d+(?:[/?#]|$)/i

export function normalizeHttpUrl(value) {
  if (value == null) return null

  const trimmed = String(value).trim()
  if (!trimmed) return null

  // Keep explicit schemes intact so validation can reject unsupported ones.
  if (URL_SCHEME_PATTERN.test(trimmed) && !HOST_PORT_PATTERN.test(trimmed)) return trimmed
  if (trimmed.startsWith('//')) return `https:${trimmed}`

  return `https://${trimmed}`
}

export function hasHttpUrlPrefix(value) {
  return HTTP_URL_PREFIX_PATTERN.test(value)
}

export function normalizeObjectUrls(object) {
  const normalized = {...object}
  for (const field of ['external_website_url', 'external_booking_url']) {
    if (Object.prototype.hasOwnProperty.call(object, field)) {
      normalized[field] = normalizeHttpUrl(object[field])
    }
  }

  if (object.external_ical) {
    normalized.external_ical = {...object.external_ical}
    if (Object.prototype.hasOwnProperty.call(object.external_ical, 'url')) {
      normalized.external_ical.url = normalizeHttpUrl(object.external_ical.url)
    }
  }

  if (Array.isArray(object.event_dates_attributes)) {
    normalized.event_dates_attributes = object.event_dates_attributes.map((date) => (
      Object.prototype.hasOwnProperty.call(date, 'ticket_url')
        ? {...date, ticket_url: normalizeHttpUrl(date.ticket_url)}
        : {...date}
    ))
  }

  return normalized
}
